var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('div',{staticClass:"large-screen-wrap",style:(_vm.largeScreenStyle)},[_c('Header'),_c('div',{staticClass:"showBlock"},[_c('leftBlock'),_c('middleBlock'),_c('rightBlock')],1),_c('bottomBlock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }